//Generated File 
export const DIALOG = `DIALOG`;
export const DIRECT = `DIRECT`;
export const NONE = `NONE`;
